/** Size, in bytes, of the out-of-band session root `R`. */
export const SESSION_ROOT_SIZE = 32;
/** Size, in bytes, of a Diffie-Hellman / PAKE shared secret. */
export const DH_SECRET_SIZE = 32;
export const X25519_PUBLIC_KEY_SIZE = 32;
export const X25519_SECRET_KEY_SIZE = 32;
export const ED25519_PUBLIC_KEY_SIZE = 32;
/**
 * Public Ed25519 secret-key size (RFC 8032 seed). sodium-native internally uses
 * a 64-byte expanded secret key (seed || public key); `ed25519Sign` accepts
 * either the 32-byte seed or the 64-byte expanded key.
 */
export const ED25519_SECRET_KEY_SIZE = 32;
export const ED25519_SIGNATURE_SIZE = 64;
export const XCHACHA20POLY1305_KEY_SIZE = 32;
export const XCHACHA20POLY1305_NONCE_SIZE = 24;
export const XCHACHA20POLY1305_TAG_SIZE = 16;
/** HKDF domain-separation labels (UTF-8 encoded when used as `info` prefix). */
export const HKDF_LABEL_CONTENT = 'fume/content/v1';
export const HKDF_LABEL_MANIFEST = 'fume/manifest/v1';
export const HKDF_LABEL_RECEIPT = 'fume/receipt/v1';
// ── S1: session root, selector, and 2-of-2 split ──────────────────────────
/** Size, in bytes, of the SHA-256 output used for the selector. */
export const SELECTOR_SIZE = 32;
/** Size, in bytes, of the per-registration selector nonce (128-bit). */
export const SELECTOR_NONCE_SIZE = 16;
/** Size, in bytes, of a single 2-of-2 XOR share (same width as the root). */
export const SHARE_SIZE = 32;
/** Size, in bytes, of the SHA-256 cross-share commitment. */
export const SHARE_COMMITMENT_SIZE = 32;
/** Share index for the paper / QR share (`share_A`). */
export const SHARE_INDEX_A = 1;
/** Share index for the phone-only deep-link share (`share_B`). */
export const SHARE_INDEX_B = 2;
/** Domain separators (UTF-8) for the S1 hash constructions. */
export const SELECTOR_DOMAIN = 'fume.selector.v1';
export const SHARE_COMMIT_DOMAIN = 'fume.share.commit.v1';
// ── S2: SPAKE2 (RFC 9382), canonical transcript, SAS ──────────────────────
/**
 * RFC 9382 §4 seed points for the P-256 ciphersuite, in compressed SEC1 hex.
 * Expanded to uncompressed points by the curve library for arithmetic.
 *   M is used by the initiator (A): pA = x*G + w*M.
 *   N is used by the responder (B): pB = y*G + w*N.
 */
export const SPAKE2_M_POINT_HEX = '02886e2f97ace46e55ba9dd7242579f2993b64e16ef3dcab95afd497333d8fa12f';
export const SPAKE2_N_POINT_HEX = '03d8bbd6c639c62937b04d997f38c3770719c629d7014d49a24b4f98baa1292b49';
/** RFC 9382 ciphersuite identifier for the pinned SPAKE2 instantiation. */
export const SPAKE2_CIPHERSUITE_ID = 'SPAKE2-P256-SHA256-HKDF-SHA256-HMAC-SHA256';
/** RFC 9382 §3.3 HKDF `info` for confirmation-key derivation from Ka. */
export const SPAKE2_CONFIRMATION_INFO = 'ConfirmationKeys';
/** Domain separator (UTF-8) for deriving the SPAKE2 password scalar `w` from R. */
export const SPAKE2_W_DOMAIN = 'fume.spake2.w.v1';
/** HKDF `info` (UTF-8) for expanding SPAKE2 `Ke` into the Fume `dh` value. */
export const SPAKE2_DH_INFO = 'fume.spake2.dh.v1';
/** Domain separator (UTF-8) for the ≥80-bit SAS derivation from the transcript. */
export const SAS_DOMAIN = 'fume.sas.v1';
/** Default Fume canonical-transcript ciphersuite id (bound into `T`). */
export const FUME_CIPHERSUITE_ID = 'FUME-SPAKE2-P256-SHA256-HKDF-HMAC/v1';
//# sourceMappingURL=constants.js.map